import type { SearchResultItemCategory } from '../../../atoms/searchResults.js'
import classes from './search-category.module.css'

type Props = {
  item: SearchResultItemCategory
}

export function SearchCategory(props: Props) {
  const {
    item: { path },
  } = props

  return <div className={classes.root}>{path}</div>
}
